<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('getUserInfo')
    this.getWindowWidth()
  },
  mounted() {
    window.addEventListener('resize', this.getWindowWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth)
  },
  methods: {
    getWindowWidth () {
      const width = window.innerWidth
      this.$store.dispatch('setWindowWidth', width)
    }
  }
}
</script>

<style lang="scss">
</style>
